// Custom Messages
export const enCustomMessages = {
  teamEfficiency: "Team Efficiency",
  teamMembers: "Team Members",
  ocupado: "Occupied",
  facturas: "Invoices",
  dashboard: "Dashboard",
  valor: "Value",
  precoHora: "Hourly rate",
  pagamentos: "Payments",
  metodoPagamento: "Payment method",
  montante: "Amount",
  posPagoHorasExtra: "Post-paid (Extra Hours)",
  numerocasifosOcupados: "Number of occupied lockers",
  reservasExpiradas : "Expired reservations",
  precoDosCacifos: "Locker price",
  gestao: "Management",
  planning: "Planning",
  profile: "Profile",
  info: "Info",
  centros: "Centers",
  estadofatura: "Invoice status",
  estadoPagamento: "Payment status",
  gestaoReservas: "Reservations management",
  reservas: "Reservations",
  language: "Language",
  trend: "Trend",
  volume: "Volume",
  myTeam: "My Team",
  allTeams: "All Teams",
  teamCalendar: "Team Calendar",
  luggage: "Luggage",
  office: "Office",
  escolherEstado: "Choose state",
  porta: "Door",
  fatura: "Invoice",
  faturaNumeroContribuinte: "Taxpayer number",
  iddoc: "Document ID",
  identificacaodocumento: "Document Number",
  idpagamento: "Payment ID",
  identidade: "Entity ID",
  validoAte: "Valid",
  taxaDeOcupacao: "Occupation rate",
  dataAtualizacao: "Update date",
  datahoraAtualizacao: "Update date",
  documento: "Document",
  dataHoraCriacaoPagamento: "Payment creation date",
  dataHoraCriacaoDocumento: "Document creation date",
  horasExtraAPagar: "Extra hours",
  pagamento: "Payment",
  dataHoraUltimaAbertura: "Last opening date",
  pagaAte: "Pay",
  estado: "State",
  tokens: "Tokens",
  reserva: "Reservation",
  saveChanges: "Save Changes",
  cancel: "Cancel",
  siteTitle: "Smart Locker",
  startFreeTrial: "Start Free Trial",
  buyNow: "Buy Now",
  getSource: "Get the source code on GitHub",
  demoInfo:
    "This demo application is built using the following Kendo UI for Angular components.",
  firstName: "First Name",
  middleName: "Middle Name",
  lastName: "Last Name",
  email: "Email Address",
  phoneNumber: "Phone Number",
  country: "Country",
  biography: "Short Biography",
  public: "Include in public directory",
  team: "Team",
  employee: "Employee",
  contactName: "Contact Name",
  jobTitle: "User type",
  status: "Status",
  performance: "Performance",
  rating: "Rating",
  engagement: "Engagement",
  budget: "Budget",
  contacts: "Contacts",
  address: "Address",
  phone: "Phone",
  gridSearch: "Search in all columns...",
  exportExcel: "Export to Excel",
  exportPdf: "Export to PDF",
  tools: "Tools",
  tool: "Tool",
  sites: "Sites",
  lockers: "Lockers",
  name: "Name",
  diretor: "Director",
  diretores: "Directors",
  brand: "Brand",
  model: "Model",
  description: "Description",
  imagem: "Image",
  serial: "Employee code",
  location: "Location",
  remoteDevice: "Remote device",
  size: "Size",
  tamanhoCacifo: "Locker size",
  doors: "Doors",
  local: "Site",
  locais: "Sites",
  ligua: "Working language",
  relatorios: "Reports",
  inventario: "Inventory",
  consumo: "Consumption",
  associacaoArtigos: "Items association",
  associacaoArtigosTeam: "Items association to team",
  associacaoArtigosArmario: "Items association to locker",
  endereco: "Address",
  descricaoFerramenta: "Tool description",
  numeroDeUtilizacoes: "Number of uses",
  addressCanal: "Address/Channel",
  inibido: "Inhibited",
  cacifosInibidos: "Inhibited lockers",
  nenhuma: "None",
  configurarArmario: "Configure locker",
  configuracaoDoArmario: "Locker configuration",
  addModulos: "Add module",
  naoPossivelMaisQueUmModuloPrincipal:
    "It´s not possibile to have more than one principal module",
  optionEletronica: "Eletronics",
  quantidadeDesejada: "Desired quantity",
  quantidadeAlertaDeStock: "Stock alert quantity",
  configuracao: "Configuration",
  escolherCentroDeCusto: "Choose cost center",
  escolherArmario: "Choose locker",
  localDoArmario: "Locker location",
  cacifosComAnomalia: "Lockers with anomalie",
  users: "Users",
  user: "User",
  employeeCode: "User ID",
  nomeCompartimento: "Door",
  numArmario: "Locker Nº",
  validade: "Valid until",
  cardID: "Card ID",
  teams: "Teams",
  numeroDeFuncionarios: "Employees",
  theField: "the field",
  isRequired: "is required",
  error: "Error",
  pt: "Portuguese",
  en: "English",
  fr: "French",
  registoGravadoComSucesso: "Record saved successfully.",
  selecionartag: "Select option",
  naoAtribuidoTag: "Not selected",
  nomeEquipa: "Team name",
  parametrosDoSistema: "System parameters",
  legenda: "Legend",
  stockBaixo: "Low stock",
  qtd: "Qty.",
  arquivoGrandeDemais: "The file exceeds the 1 MB size limit.",
  parametros: "Parameters",
  smtpServer: "SMTP Server",
  smtpPort: "SMTP Port",
  smtpPass: "SMTP Pass",
  smtpFrom: "SMTP From",
  UrlRecuperacaoPwd: "Password recovery URI",
  EmailUsername: "User email",
  tooltypes: "Tool types",
  toolsubtypes: "Tool subtypes",
  size: "Locker size",
  descontinuado: "Discontinued",
  identificacao: "Tool ID",
  numeroDeSerie: "Serial number",
  obs: "Observations",
  condicao: "Condition",
  state: "State",
  avaria: "Damage",
  listaDeAvarias: "List of typical damages",
  novoTipoAvaria: "New type of damage",
  configuracoes: "Settings",
  gestaoArmarios: "Cabinets management",
  gestaoUtilizadores: "Users management",
  gestaoFerramentas: "Tools management",
  gestaoArtigos: "Items management",
  artigos: "Items",
  centrosDeCusto: "Cost centers",
  cacifosComStockBaixo: "Lockers with low stock",
  listaDeFerramentas: "Tool list",
  confirmacao: "Confirmation",
  desejaRemover: "Are you sure you want to remove the selected record?",
  yes: "Yes",
  no: "No",
  tooltype: "Tool type",
  toolsubtype: "Tool subtype",
  localPretty: "Tool locker location",
  supervisores: "Supervisors",
  codigo: "Code",
  import: "Import",
  avariada: "Broken",
  toolTypeDados: "Details",
  terminarSessao: "Log out",
  perfilAdministrador: "Administrator",
  ferramentasDiponiveisEquipa: "Type of tools available to the team ",
  artigosDiponiveisEquipa: "Type of items available to the team ",
  erroExtensaoFicheiroInvalida: "Error: File extension not allowed.",
  importarUtilizadores: "Import users",
  importarFerramentas: "Import tools",
  totalFerramentas: "Tools total",
  ferramentasIndisponiveis: "Unavailable tools",
  ferramentasAutorizadas: "Authorized tools",
  selecionar: "<Select>",
  abatida: "No longer in use",
  bloqueada: "Blocked",
  descarregarModelo: "Download template",
  corPrincipal: "Main color",
  corSecundaria: "Secondary color",
  quantidadeRemover: "Quantity to remove",
  filtrar: "Filter",
  quantidadeRepor: "Quantity to report",
  anomalias: "Anomalies",
  filtrarEntreDatas: "Filter between dates",
  infoFerramentasAutorizadas:
    "Indicate the maximum number of Tools, of each Type, that a member of this Team can have in their possession at the same time.",
  ativa: "Active",
  bloqueada: "Blocked",
  pendente: "Pending",
  depositada: "Deposited",
  levantada: "Raised",
  eventos: "Events",
  movimentos: "Movements",
  movDataHora: "Date Hour",
  alterarPassword: "Change password",
  atualPassword: "Current password",
  novaPassword: "New password",
  novaPasswordNovamente: "Repeat the new password",
  passwordAlteradaComSucesso: "Password successfully changed",
  passwordsNaoSaoIguais: "Passwords don´t match",
  erroLoginNecessario: "Error: login is required",
  erroPasswordNecessaria: "Error: password is required",
  esqueceuPassword: "Forgot password?",
  loginSenhaInvalidos: "Login or password invalid.",
  recuperarPassword: "Recover password",
  btnEnviar: "Send",
  escolherLocal: "Select site",
  outrosIndicadores: "Other indicators",
  ferramentasNaoDepositadas: "Tools not delivered",
  portasIbibidas: "Inhibited ports",
  utilizadoresAusentes: "Absent users",
  ferramentasBloqueadas: "Blocked tools",
  estadoFerramentas: "Tools state",
  avariasReportadas: "Reported damages",
  ocupacaoArmarios: "Locker usage",
  tipos: "Types",
  btnEliminar: "Delete",
  btnCriar: "Create",
  btnAdicionar: "Add",
  btnEditar: "Edit",
  btnVisualizar: "Preview",
  btnVisualizarEstadoArmario: "View Cabinet status",
  btnExportarExcel: "Export Excel",
  btnExportarPDF: "Export PDF",
  btnFerramentasAutorizadas: "Authorized tools",
  btnArtigosAutorizados: "Authorized items",
  btnImportar: "Import",
  artigo: "Item",
  codigoInterno: "Internal code",
  codigoFabricante: "Manufacturer code",
  quantidade: "Quantity",
  quantidadeRemanescente: "Remaining quantity",
  stock: "Stock",
  mostrarArtigosDescontinuados: "Show discontinued items",
  importarArtigos: "Import items",
  centroDeCusto: "Cost center",
  mostrarCentrosDeCustoDescontinuados: "Show discontinued cost centers",
  importarCentrosDeCusto: "Import cost centers",
  entidades: "Entities",
  entidade: "Entity",
  solucao: "Solution",
  tipo: "Type",
  armario: "Cabinet",
  cacifo: "Locker",
  anomalia: "Anomaly",
  alerta: "Alert",
  alertas: "Alerts",
  notas: "Notes",
  pagina: "Page",
  de_: "of",
  armario: "Cabinet",
  armarios: "Cabinets",
  modulo: "Module",
  modulos: "Modules",
  cacifo: "Locker",
  cacifos: "Lockers",
  estadoDoArmario: "Cabinet status",
  configurcaoDoArmario: "Cabinet configuration",
  selecionarImagem: "Select image",
  largueAImagemAqui: "Drop image here",
  extensaoFicheiroNaoSuportada: "File extension not allowed",
  visaoGeral: "Overview",
    //Versões  
    versoes: "Versions",
    versaoWeb: "Web version",
    versaoBackend: "Backend version",

    forgotPassword: "Forgot password",
};

export const enComponentMessages = {
  "kendo.grid.groupPanelEmpty":
    "Drag a column header and drop it here to group by that column",
  "kendo.grid.noRecords": "No records available.",
  "kendo.grid.pagerFirstPage": "Go to the first page",
  "kendo.grid.pagerPreviousPage": "Go to the previous page",
  "kendo.grid.pagerNextPage": "Go to the next page",
  "kendo.grid.pagerLastPage": "Go to the last page",
  "kendo.grid.pagerPage": "Page",
  "kendo.grid.pagerOf": "of",
  "kendo.grid.pagerItems": "items",
  "kendo.grid.pagerItemsPerPage": "items per page",
  "kendo.grid.pagerPageNumberInputTitle": "Page Number",
  "kendo.grid.filter": "Filter",
  "kendo.grid.filterEqOperator": "Is equal to",
  "kendo.grid.filterNotEqOperator": "Is not equal to",
  "kendo.grid.filterIsNullOperator": "Is null",
  "kendo.grid.filterIsNotNullOperator": "Is not null",
  "kendo.grid.filterIsEmptyOperator": "Is empty",
  "kendo.grid.filterIsNotEmptyOperator": "Is not empty",
  "kendo.grid.filterStartsWithOperator": "Starts with",
  "kendo.grid.filterContainsOperator": "Contains",
  "kendo.grid.filterNotContainsOperator": "Does not contain",
  "kendo.grid.filterEndsWithOperator": "Ends with",
  "kendo.grid.filterGteOperator": "Is greater than or equal to",
  "kendo.grid.filterGtOperator": "Is greater than",
  "kendo.grid.filterLteOperator": "Is less than or equal to",
  "kendo.grid.filterLtOperator": "Is less than",
  "kendo.grid.filterIsTrue": "is true",
  "kendo.grid.filterIsFalse": "is false",
  "kendo.grid.filterBooleanAll": "(All)",
  "kendo.grid.filterAfterOrEqualOperator": "Is after or equal to",
  "kendo.grid.filterAfterOperator": "Is after",
  "kendo.grid.filterBeforeOperator": "Is before",
  "kendo.grid.filterBeforeOrEqualOperator": "Is before or equal to",
  "kendo.grid.filterFilterButton": "Filter",
  "kendo.grid.filterClearButton": "Clear",
  "kendo.grid.filterAndLogic": "And",
  "kendo.grid.filterOrLogic": "Or",
  "kendo.grid.filterDateToggle": "Toggle calendar",
  "kendo.grid.filterDateToday": "Today",
  "kendo.grid.filterNumericDecrement": "Decrease value",
  "kendo.grid.filterNumericIncrement": "Increase value",
  "kendo.grid.loading": "Loading",
  "kendo.grid.sort": "Sort",
  "kendo.grid.columnMenu": "Column Menu",
  "kendo.grid.columns": "Columns",
  "kendo.grid.lock": "Lock",
  "kendo.grid.unlock": "Unlock",
  "kendo.grid.stick": "Stick",
  "kendo.grid.unstick": "Unstick",
  "kendo.grid.setColumnPosition": "Set Column Position",
  "kendo.grid.sortAscending": "Sort Ascending",
  "kendo.grid.sortDescending": "Sort Descending",
  "kendo.grid.columnsApply": "Apply",
  "kendo.grid.columnsReset": "Reset",
  "kendo.grid.sortable": "Sortable",
  "kendo.grid.sortedAscending": "Sorted ascending",
  "kendo.grid.sortedDescending": "Sorted descending",
  "kendo.grid.sortedDefault": "Not sorted",
  "kendo.autocomplete.noDataText": "No data found",
  "kendo.autocomplete.clearTitle": "Clear",
  "kendo.combobox.noDataText": "No data found",
  "kendo.combobox.clearTitle": "Clear",
  "kendo.dropdownlist.noDataText": "No data found",
  "kendo.dropdownlist.clearTitle": "Clear",
  "kendo.calendar.today": "TODAY",
  "kendo.textbox.clearTitle": "Clear",
  "kendo.datepicker.today": "TODAY",
  "kendo.datepicker.toggle": "Toggle calendar",
  "kendo.dateinput.increment": "Increase value",
  "kendo.dateinput.decrement": "Decrease value",
  "kendo.numerictextbox.increment": "Increase value",
  "kendo.numerictextbox.decrement": "Decrease value",
  "kendo.datetimepicker.dateTab": "Date",
  "kendo.datetimepicker.dateTabLabel": "Date tab",
  "kendo.datetimepicker.timeTab": "Time",
  "kendo.datetimepicker.timeTabLabel": "Time tab",
  "kendo.datetimepicker.toggle": "Toggle popup",
  "kendo.datetimepicker.accept": "Set",
  "kendo.datetimepicker.acceptLabel": "Set",
  "kendo.datetimepicker.cancel": "Cancel",
  "kendo.datetimepicker.cancelLabel": "Cancel",
  "kendo.datetimepicker.now": "NOW",
  "kendo.datetimepicker.nowLabel": "Select now",
  "kendo.datetimepicker.today": "TODAY",
  "kendo.datetimepicker.prevButtonTitle": "Navigate to previous view",
  "kendo.datetimepicker.nextButtonTitle": "Navigate to next view",
  "kendo.timepicker.accept": "Set",
  "kendo.timepicker.acceptLabel": "Set",
  "kendo.timepicker.cancel": "Cancel",
  "kendo.timepicker.cancelLabel": "Cancel",
  "kendo.timepicker.now": "Now",
  "kendo.timepicker.nowLabel": "Now",
  "kendo.timepicker.toggle": "Toggle time list",
  "kendo.fileselect.cancel": "Cancel",
  "kendo.fileselect.clearSelectedFiles": "Clear",
  "kendo.fileselect.dropFilesHere": "Drop files here to upload",
  "kendo.fileselect.externalDropFilesHere":
    "Drag and drop files here to upload",
  "kendo.fileselect.filesBatchStatus": "files",
  "kendo.fileselect.filesBatchStatusFailed": "files failed to upload.",
  "kendo.fileselect.filesBatchStatusUploaded": "files successfully uploaded.",
  "kendo.fileselect.fileStatusFailed": "File failed to upload.",
  "kendo.fileselect.fileStatusUploaded": "File successfully uploaded.",
  "kendo.fileselect.headerStatusPaused": "Paused",
  "kendo.fileselect.headerStatusUploaded": "Done",
  "kendo.fileselect.headerStatusUploading": "Uploading...",
  "kendo.fileselect.invalidFileExtension": "File type not allowed.",
  "kendo.fileselect.invalidMaxFileSize": "File size too large.",
  "kendo.fileselect.invalidMinFileSize": "File size too small.",
  "kendo.fileselect.remove": "Remove",
  "kendo.fileselect.retry": "Retry",
  "kendo.fileselect.select": "Select files...",
  "kendo.fileselect.uploadSelectedFiles": "Upload files",
  "kendo.scheduler.agendaViewTitle": "Agenda",
  "kendo.scheduler.allDay": "all day",
  "kendo.scheduler.allEvents": "All events",
  "kendo.scheduler.calendarToday": "TODAY",
  "kendo.scheduler.cancel": "Cancel",
  "kendo.scheduler.save": "Save",
  "kendo.scheduler.editorEventTitle": "Title",
  "kendo.scheduler.editorEventStart": "Start",
  "kendo.scheduler.editorEventStartTimeZone": "Start Time Zone",
  "kendo.scheduler.editorEventEnd": "End",
  "kendo.scheduler.editorEventEndTimeZone": "End Time Zone",
  "kendo.scheduler.dateHeader": "Date",
  "kendo.scheduler.dayViewTitle": "Day",
  "kendo.scheduler.deleteConfirmation":
    "Are you sure you want to delete this event?",
  "kendo.scheduler.deleteDialogTitle": "Delete Event",
  "kendo.scheduler.deleteOccurrence": "Delete current occurrence",
  "kendo.scheduler.deleteRecurringConfirmation":
    "Do you want to delete only this event occurrence or the whole series?",
  "kendo.scheduler.deleteRecurringDialogTitle": "Delete Recurring Item",
  "kendo.scheduler.deleteSeries": "Delete the series",
  "kendo.scheduler.deleteTitle": "Delete",
  "kendo.scheduler.destroy": "Delete",
  "kendo.scheduler.editOccurrence": "Edit current occurrence",
  "kendo.scheduler.editorEventAllDay": "All Day Event",
  "kendo.scheduler.editorEventDescription": "Description",
  "kendo.scheduler.editorEventSeparateTimeZones": "End in different Time Zone",
  "kendo.scheduler.editorEventTimeZone": "Specify Time Zone",
  "kendo.scheduler.editorTitle": "Event",
  "kendo.scheduler.editRecurringConfirmation":
    "Do you want to edit only this event occurrence or the whole series?",
  "kendo.scheduler.editRecurringDialogTitle": "Edit Recurring Item",
  "kendo.scheduler.editSeries": "Edit the series",
  "kendo.scheduler.eventHeader": "Event",
  "kendo.scheduler.monthViewTitle": "Month",
  "kendo.scheduler.multiDayViewTitle": "Multi-Day",
  "kendo.scheduler.nextTitle": "Next",
  "kendo.scheduler.previousTitle": "Previous",
  "kendo.scheduler.recurrenceEditorDailyInterval": "day(s)",
  "kendo.scheduler.recurrenceEditorDailyRepeatEvery": "Repeat every",
  "kendo.scheduler.recurrenceEditorEndAfter": "After",
  "kendo.scheduler.recurrenceEditorEndLabel": "End",
  "kendo.scheduler.recurrenceEditorEndNever": "Never",
  "kendo.scheduler.recurrenceEditorEndOccurrence": "occurrence(s)",
  "kendo.scheduler.recurrenceEditorEndOn": "On",
  "kendo.scheduler.recurrenceEditorFrequenciesDaily": "Daily",
  "kendo.scheduler.recurrenceEditorFrequenciesMonthly": "Monthly",
  "kendo.scheduler.recurrenceEditorFrequenciesNever": "Never",
  "kendo.scheduler.recurrenceEditorFrequenciesWeekly": "Weekly",
  "kendo.scheduler.recurrenceEditorFrequenciesYearly": "Yearly",
  "kendo.scheduler.recurrenceEditorMonthlyDay": "Day",
  "kendo.scheduler.recurrenceEditorMonthlyInterval": "month(s)",
  "kendo.scheduler.recurrenceEditorMonthlyRepeatEvery": "Repeat every",
  "kendo.scheduler.recurrenceEditorMonthlyRepeatOn": "Repeat on",
  "kendo.scheduler.recurrenceEditorOffsetPositionsFirst": "First",
  "kendo.scheduler.recurrenceEditorOffsetPositionsFourth": "Fourth",
  "kendo.scheduler.recurrenceEditorOffsetPositionsLast": "Last",
  "kendo.scheduler.recurrenceEditorOffsetPositionsSecond": "Second",
  "kendo.scheduler.recurrenceEditorOffsetPositionsThird": "Third",
  "kendo.scheduler.recurrenceEditorRepeat": "Repeat",
  "kendo.scheduler.recurrenceEditorWeekdaysDay": "Day",
  "kendo.scheduler.recurrenceEditorWeekdaysWeekday": "Weekday",
  "kendo.scheduler.recurrenceEditorWeekdaysWeekendday": "Weekend Day",
  "kendo.scheduler.recurrenceEditorWeeklyInterval": "week(s)",
  "kendo.scheduler.recurrenceEditorWeeklyRepeatEvery": "Repeat every",
  "kendo.scheduler.recurrenceEditorWeeklyRepeatOn": "Repeat on",
  "kendo.scheduler.recurrenceEditorYearlyInterval": "year(s)",
  "kendo.scheduler.recurrenceEditorYearlyOf": "of",
  "kendo.scheduler.recurrenceEditorYearlyRepeatEvery": "Repeat every",
  "kendo.scheduler.recurrenceEditorYearlyRepeatOn": "Repeat on",
  "kendo.scheduler.showFullDay": "Show full day",
  "kendo.scheduler.showWorkDay": "Show business hours",
  "kendo.scheduler.timeHeader": "Time",
  "kendo.scheduler.timelineMonthViewTitle": "Timeline Month",
  "kendo.scheduler.timelineViewTitle": "Timeline",
  "kendo.scheduler.timelineWeekViewTitle": "Timeline Week",
  "kendo.scheduler.today": "Today",
  "kendo.scheduler.weekViewTitle": "Week",
  "kendo.scheduler.workWeekViewTitle": "Work Week",
  "kendo.recurrenceeditor.dailyInterval": "day(s)",
  "kendo.recurrenceeditor.dailyRepeatEvery": "Repeat every",
  "kendo.recurrenceeditor.endAfter": "After",
  "kendo.recurrenceeditor.endLabel": "End",
  "kendo.recurrenceeditor.endNever": "Never",
  "kendo.recurrenceeditor.endOccurrence": "occurrence(s)",
  "kendo.recurrenceeditor.endOn": "On",
  "kendo.recurrenceeditor.frequenciesDaily": "Daily",
  "kendo.recurrenceeditor.frequenciesMonthly": "Monthly",
  "kendo.recurrenceeditor.frequenciesNever": "Never",
  "kendo.recurrenceeditor.frequenciesWeekly": "Weekly",
  "kendo.recurrenceeditor.frequenciesYearly": "Yearly",
  "kendo.recurrenceeditor.monthlyDay": "Day",
  "kendo.recurrenceeditor.monthlyInterval": "month(s)",
  "kendo.recurrenceeditor.monthlyRepeatEvery": "Repeat every",
  "kendo.recurrenceeditor.monthlyRepeatOn": "Repeat on",
  "kendo.recurrenceeditor.offsetPositionsFourth": "Fourth",
  "kendo.recurrenceeditor.offsetPositionsLast": "Last",
  "kendo.recurrenceeditor.offsetPositionsSecond": "Second",
  "kendo.recurrenceeditor.offsetPositionsThird": "Third",
  "kendo.recurrenceeditor.repeat": "Repeat",
  "kendo.recurrenceeditor.weekdaysDay": "Day",
  "kendo.recurrenceeditor.weekdaysWeekday": "Weekday",
  "kendo.recurrenceeditor.weekdaysWeekendday": "Weekend Day",
  "kendo.recurrenceeditor.weeklyInterval": "week(s)",
  "kendo.recurrenceeditor.weeklyRepeatEvery": "Repeat every",
  "kendo.recurrenceeditor.weeklyRepeatOn": "Repeat on",
  "kendo.recurrenceeditor.yearlyInterval": "year(s)",
  "kendo.recurrenceeditor.yearlyOf": "of",
  "kendo.recurrenceeditor.yearlyRepeatEvery": "Repeat every",
  "kendo.recurrenceeditor.yearlyRepeatOn": "Repeat on",
};
